import { render } from "./GiftVoucher.vue?vue&type=template&id=39112d16"
import script from "./GiftVoucher.vue?vue&type=script&lang=js"
export * from "./GiftVoucher.vue?vue&type=script&lang=js"
script.render = render

export default script